<template>
    <div :class="className">{{ value }}</div>
</template>

<script>
export default {
    props: ["value"],
    computed: {
        className() {
            return this.value && this.value.toLowerCase().replace(" ", "_");
        }
    }
};
</script>

<style scoped lang="scss">
div {
    line-height: 23px;
    font-size: 12px;
    text-align: center;
    color: white;

    .in_progress {
        background-color: #ff7b15;
    }

    .approved {
        background-color: #8ab400;
    }

    .archived {
        background-color: #a3a3a3;
    }

    .submitted {
        background-color: #41b4e8;
    }
}
</style>



// WEBPACK FOOTER //
// status.vue?321d8dfe